import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import state from "./state";

// The estimator query is intentionally NOT persisted (FCI-91/FCI-92). The form
// resets after every submit and after a page refresh, so there is nothing to
// restore from sessionStorage. The previous vuex-persist plugin (which only
// persisted valuationRequest) has been removed.

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
});
